/**
 * 通用混合
 * */
export default {
  data() {
    return {};
  },
  methods: {
    // 当 $route 更新时触发
    appRouteChange() {}
  }
};
